import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import Button from '../Button/Button.component';
import EnvListItem from '../EnvListItem/EnvListItem.component';
import { SelectorContext } from '../../contexts/selector.context';
import { environmentList } from '../../config/environment.config';

import {
  EnvSelectorContainer,
  EmptyMessage,
  EnvItems,
} from './EnvSelector.styles';

const EnvSelector = () => {
  const navigate = useNavigate();
  const { isSelectorOpen, setSelectorState } = useContext(SelectorContext);

  const goToDashboardHandler = () => {
    setSelectorState(!isSelectorOpen);
    navigate('/home/');
  };

  return (
    <EnvSelectorContainer>
      <EnvItems>
        {environmentList.length ? (
          environmentList.map((envitem) => {
            return <EnvListItem key={envitem.code} envItem={envitem} />
          }
        )) : (
          <EmptyMessage>No Environment Configured</EmptyMessage>
        )}
      </EnvItems>
      <Button onClick={goToDashboardHandler}>SERVICE DASHBOARD</Button>
    </EnvSelectorContainer>
  );
};

export default EnvSelector;